import {
  Grid,
  GridItem,
  Heading,
  Text,
  useMediaQuery,
  theme,
  Container,
  Box,
} from '@everlywell/ui-kit';
import Carousel from 'components/Carousel';
import GridCard, { GridCardProps } from 'components/GridCard';
import React from 'react';

// Types ----------

export interface GridCardListProps {
  cards: GridCardProps[];
  eyebrow: string;
  title: string;
}

// GridCardList ------

const GridCardList: React.FC<GridCardListProps | null> = (props) => {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.tablet})`);

  if (!props) {
    return null;
  }

  const { cards, eyebrow, title } = props;

  const GridCards = cards.map((card, index: number) => (
    <GridCard key={`card-${index}`} {...card} />
  ));

  const oddNumberOfCards = GridCards.length % 2 !== 0;

  return (
    <Container size={['sm', 'sm', 'xl', 'xl', 'xl']} overflow="hidden">
      <Grid alignEdges spacing={[6, 6, 5]} maxWidth={['100vw', '100%']}>
        <GridItem width={[1, 1 / 3]}>
          <Text
            size="xl"
            marginBottom={['1', '2']}
            color={theme.colors.viridian.base}
            textAlign={['center', 'left']}
          >
            {eyebrow}
          </Text>

          <Heading
            // @ts-ignore
            size={['32px', '2xl']}
            textAlign={['center', 'left']}
          >
            {title}
          </Heading>
        </GridItem>

        <GridItem width={[1, 2 / 3]}>
          <>
            {isMobile ? (
              <Box marginRight="-24px">
                <Carousel
                  spaceBetween={16}
                  slidesPerView={'auto'}
                  pagination={GridCards.length > 1}
                  style={{ paddingRight: '24px' }}
                >
                  {cards.map((card, index) => (
                    <GridCard key={`grid-card-${index}`} {...card} />
                  ))}
                </Carousel>
              </Box>
            ) : (
              <Grid spacing={5}>
                {cards.map((card, index) => {
                  const firstCardFullWidth = oddNumberOfCards && index === 0;
                  return (
                    <GridItem
                      key={`grid-card-${index}`}
                      width={[1, firstCardFullWidth ? 1 : 1 / 2]}
                      marginBottom={64}
                    >
                      <GridCard
                        {...card}
                        imageStyles={{
                          ...(firstCardFullWidth
                            ? { aspectRatio: 2.5, width: '100%' }
                            : {}),
                        }}
                      />
                    </GridItem>
                  );
                })}
              </Grid>
            )}
          </>
        </GridItem>
      </Grid>
    </Container>
  );
};

// Export ---------

export default GridCardList;
